export function numberToWords(num) {
  if (num === undefined || num === null || isNaN(num)) return '';
  if (num === 0) return 'Zero';

  const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const inWords = (n) => {
    if (n < 20) return a[n];
    const tens = Math.floor(n / 10);
    const units = n % 10;
    return b[tens] + (units > 0 ? '-' + a[units] : ' ');
  };

  const toWords = (n) => {
    if (n === 0) return '';
    if (n < 100) return inWords(n);
    if (n < 1000) {
      const hundreds = Math.floor(n / 100);
      const rem = n % 100;
      return a[hundreds] + 'Hundred ' + (rem > 0 ? 'and ' + inWords(rem) : '');
    }
    if (n < 100000) {
      const thousands = Math.floor(n / 1000);
      const rem = n % 1000;
      return toWords(thousands) + 'Thousand ' + toWords(rem);
    }
    if (n < 10000000) {
      const lakhs = Math.floor(n / 100000);
      const rem = n % 100000;
      return toWords(lakhs) + 'Lakh ' + toWords(rem);
    }
    const crores = Math.floor(n / 10000000);
    const rem = n % 10000000;
    return toWords(crores) + 'Crore ' + toWords(rem);
  };

  const numStr = Number(num).toFixed(2);
  const parts = numStr.split('.');
  const intPart = parseInt(parts[0], 10);
  const decPart = parseInt(parts[1], 10);

  let result = toWords(intPart).trim();
  if (decPart > 0) {
    result += ' and ' + toWords(decPart).trim() + ' Cents';
  }
  
  return result;
}
